import { apiClient } from '@/lib/api-client';

export interface TenantDetail {
  id: string;
  business_name: string;
  business_type: 'RETAIL' | 'RESTAURANT';
  gstin?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  logo_url?: string;
  status: string;
  subscription_plan?: string;
  trial_ends_at?: string;
  default_currency: string;
  backup_hour_utc?: number;
  primary_color?: string;
  secondary_color?: string;
  receipt_footer?: string;
  invoice_header?: string;
  show_gstin_on_receipt?: boolean;
  /** Absent when the store was filled from /auth/me (non-owner roles). */
  created_at?: string;
  updated_at?: string;
}

export interface UpdateProfileData {
  gstin?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  pincode?: string | null;
  phone?: string | null;
  logo_url?: string | null;
}

export interface UpdateBrandingData {
  logo_url?: string | null;
  primary_color?: string | null;
  secondary_color?: string | null;
  receipt_footer?: string | null;
  invoice_header?: string | null;
}

export interface UpdateBackupData {
  backup_hour_utc: number;
}

// Backend updateBranding returns a partial shape, NOT a full TenantDetail
export interface BrandingResponse {
  tenant_id: string;
  logo_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  receipt_footer: string | null;
  invoice_header: string | null;
  updated_at: string;
}

export const tenantService = {
  getTenant(tenantId: string) {
    return apiClient<TenantDetail>(`/tenants/${tenantId}`);
  },

  updateProfile(tenantId: string, data: UpdateProfileData) {
    return apiClient<TenantDetail>(`/tenants/${tenantId}/profile`, {
      method: 'PATCH',
      body: data,
    });
  },

  updateBranding(data: UpdateBrandingData) {
    return apiClient<BrandingResponse>('/tenant-branding', {
      method: 'PATCH',
      body: data,
    });
  },

  updateBackupSettings(tenantId: string, data: UpdateBackupData) {
    return apiClient<TenantDetail>(`/tenants/${tenantId}/backup-settings`, {
      method: 'PATCH',
      body: data,
    });
  },

};
